(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["machine-directory"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-machine-directory]').forEach((directory) => {
    if (directory.dataset.ready === 'true') return;
    directory.dataset.ready = 'true';
    const cards = [...directory.querySelectorAll('[data-brand-card]')];
    const requestedBrand = decodeURIComponent(window.location.hash.slice(1)).toLowerCase();
    const activeCard = cards.find((card) => card.dataset.brandCard === requestedBrand);
    const search = directory.querySelector('[data-machine-search]');
    const searchWrap = directory.querySelector('[data-search-wrap]');
    const empty = directory.querySelector('[data-machine-empty]');
    const invalid = directory.querySelector('[data-machine-invalid]');
    const status = directory.querySelector('[data-machine-status]');
    const activeBrandLabel = directory.querySelector('[data-active-brand]');

    if (!activeCard) {
      invalid.hidden = false;
      return;
    }

    activeCard.hidden = false;
    activeBrandLabel.textContent = activeCard.dataset.brandName;
    const models = [...activeCard.querySelectorAll('[data-machine-model]')];
    searchWrap.hidden = models.length === 0;

    search.addEventListener('input', () => {
      const term = search.value.trim().toLowerCase();
      let visible = 0;
      models.forEach((model) => {
        const matches = !term || model.dataset.searchText.includes(term);
        model.classList.toggle('is-filtered', !matches);
        if (matches) visible += 1;
      });
      empty.hidden = visible > 0;
      activeCard.hidden = visible === 0;
      const resultLabel = visible === 1 ? directory.dataset.resultOne : directory.dataset.resultMany;
      status.textContent = term ? `${visible} ${resultLabel} in ${activeCard.dataset.brandName}` : '';
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["machine-parts-directory"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-machine-parts]').forEach((section) => {
    if (section.dataset.ready === 'true') return;
    section.dataset.ready = 'true';
    const params = new URLSearchParams(window.location.search);
    const brand = (params.get('brand') || '').trim();
    const model = (params.get('model') || '').trim();
    const invalid = section.querySelector('[data-machine-invalid]');
    const searchPanel = section.querySelector('.machine-parts__search-panel');
    const categories = section.querySelector('.machine-parts__categories');
    const help = section.querySelector('.machine-parts__help');

    if (!brand || !model) {
      invalid.hidden = false;
      searchPanel.hidden = true;
      categories.hidden = true;
      help.hidden = true;
      return;
    }

    const machineName = `${brand} ${model}`;
    section.querySelector('[data-machine-name]').textContent = `${machineName} parts`;
    section.querySelector('[data-search-machine]').textContent = machineName;
    section.querySelector('[data-back-link]').href = `${section.querySelector('[data-back-link]').getAttribute('href')}#${brand.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`;
    const searchForm = section.querySelector('[data-parts-search-form]');
    const termInput = section.querySelector('[data-part-term]');
    const queryInput = section.querySelector('[data-parts-query]');
    const displayQueryInput = section.querySelector('[data-display-query]');
    section.querySelector('[data-scope-brand]').value = brand;
    section.querySelector('[data-scope-model]').value = model;

    const escapeSearchValue = (value) => value.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
    const machineQuery = `tag:"${escapeSearchValue(brand)}" AND tag:"${escapeSearchValue(model)}"`;

    const searchFor = (productType) => {
      const query = `${machineQuery} AND product_type:"${escapeSearchValue(productType)}"`;
      const searchParams = new URLSearchParams({
        type: 'product',
        'options[prefix]': 'none',
        q: query,
        display_q: productType,
        scope_brand: brand,
        scope_model: model,
        scope_type: productType
      });
      window.location.href = `${searchForm.action}?${searchParams.toString()}`;
    };

    searchForm.addEventListener('submit', (event) => {
      event.preventDefault();
      const visibleTerm = termInput.value.trim();
      queryInput.value = `${machineQuery} AND "${escapeSearchValue(visibleTerm)}"`;
      displayQueryInput.value = visibleTerm;
      searchForm.submit();
    });

    section.querySelectorAll('[data-part-category]').forEach((button) => {
      button.addEventListener('click', () => searchFor(button.dataset.partCategory));
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  document.querySelectorAll('.template-search__search form[role="search"]').forEach((form) => {
    if (form.dataset.friendlySearchReady === 'true') return;
    form.dataset.friendlySearchReady = 'true';
    const input = form.querySelector('input[name="q"]');
    if (!input) return;
    const params = new URLSearchParams(window.location.search);
    const originalQuery = input.value;
    const typeMatch = originalQuery.match(/product_type:"([^"]+)"/);
    const quotedValues = [...originalQuery.matchAll(/"([^"]+)"/g)].map((match) => match[1]);
    const friendlyTerm = params.get('display_q') || (typeMatch ? typeMatch[1] : quotedValues[quotedValues.length - 1]);
    if (!friendlyTerm || !originalQuery.includes('tag:"')) return;
    input.value = friendlyTerm;

    form.addEventListener('submit', () => {
      const visibleTerm = input.value.trim();
      const brand = params.get('scope_brand') || quotedValues[0] || '';
      const model = params.get('scope_model') || quotedValues[1] || '';
      const productType = params.get('scope_type') || (typeMatch ? typeMatch[1] : '');
      if (!brand || !model || !visibleTerm) return;
      const escapeValue = (value) => value.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
      const sameCategory = productType && visibleTerm === friendlyTerm;
      const finalTerm = sameCategory
        ? `product_type:"${escapeValue(productType)}"`
        : `"${escapeValue(visibleTerm)}"`;
      input.value = `tag:"${escapeValue(brand)}" AND tag:"${escapeValue(model)}" AND ${finalTerm}`;
      const displayInput = document.createElement('input');
      displayInput.type = 'hidden';
      displayInput.name = 'display_q';
      displayInput.value = visibleTerm;
      form.appendChild(displayInput);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
